<template>
  <div>
    <RightSidebar :isActive.sync="isActive" size="large">
      <template #header>
        <img width="40" :src="ProductIcon" class="mr-4" />
        <div>
          <h4>Assigned sales product</h4>
          <small v-if="product"> {{ product.salesProduct.id }} • {{ product.salesProduct.name }} </small>
        </div>
      </template>

      <template #content>
        <Loading v-if="isLoading" />
        <div v-else>
          <!-- <section class="px-6 pt-6 grid grid-cols-4 gap-x-8">
            <SidebarItem label="Country">
              <vs-select
                v-model="product.salesProduct.countryId"
                class="w-full"
                :disabled="true"
              >
                <vs-select-item
                  :key="index"
                  :value="item.countryId.id"
                  :text="item.name"
                  v-for="(item, index) in countries"
                />
              </vs-select>
            </SidebarItem>
          </section> -->

          <!-- <vs-divider /> -->

          <section class="px-6 grid grid-cols-4 gap-x-8 mt-4">
            <SidebarItem label="Name" class="col-span-2">
              <vs-input class="w-full" v-model="product.salesProduct.name" :disabled="true" />
            </SidebarItem>

            <SidebarItem label="Color" class="col-span-2 row-span-2">
              <input
                type="color"
                v-model="product.salesProduct.color"
                class="w-32 h-32 rounded-lg border border-solid custom-color-picker"
                style="border-color: #eee"
                :style="'--color-picker-color:' + product.color + '62'"
                :disabled="true"
              />
            </SidebarItem>

            <SidebarItem label="Guide text" class="col-span-2 row-span-2">
              <vs-textarea class="w-full h-full" v-model="product.salesProduct.helpText" :disabled="true" />
            </SidebarItem>

            <SidebarItem label="Double sales product" v-if="!isPriceable">
              <vs-select v-model="product.salesProduct.doubleProductId" autocomplete class="w-full" :disabled="true">
                <vs-select-item key="empty" :value="null" text="None" />
                <vs-select-item :key="item.id" :value="item.id" :text="item.name" v-for="item in salesProducts" />
              </vs-select>
            </SidebarItem>
            <SidebarItem label="Triple sales product" v-if="!isPriceable">
              <vs-select v-model="product.salesProduct.tripleProductId" autocomplete :disabled="true" class="w-full">
                <vs-select-item key="empty" :value="null" text="None" />
                <vs-select-item :key="item.id" :value="item.id" :text="item.name" v-for="item in salesProducts" />
              </vs-select>
            </SidebarItem>

            <SidebarItem label="Sales group" class="col-start-1">
              <vs-select v-model="product.salesProduct.salesProductGroupId" class="w-full" :disabled="true">
                <vs-select-item
                  :key="index"
                  :value="item.salesProductGroupId.id"
                  :text="item.name"
                  v-for="(item, index) in salesGroups"
                  :disabled="true"
                />
              </vs-select>
            </SidebarItem>

            <SidebarItem label="Sub sales group">
              <vs-select v-model="product.salesProduct.salesProductSubGroupId" class="w-full" :disabled="true">
                <vs-select-item key="empty" :value="null" text="None" />
                <vs-select-item
                  :key="index"
                  :value="item.salesProductSubGroupId.id"
                  :text="item.name"
                  v-for="(item, index) in salesSubGroups"
                />
              </vs-select>
            </SidebarItem>

            <SidebarItem label="Product type">
              <vs-select v-model="product.salesProduct.salesProductType" :disabled="true">
                <vs-select-item
                  :key="item.value"
                  :value="item.value"
                  :text="item.name"
                  v-for="item in [
                    { value: 'Stock', name: 'Stock type' },
                    { value: 'Split', name: 'Split type' },
                    { value: 'Priceable', name: 'Priceable type' }
                  ]"
                />
              </vs-select>
            </SidebarItem>

            <SidebarItem label="VAT rate" v-if="!isSplit">
              <vs-select :value="product.salesProduct.taxGroupId" :disabled="true">
                <vs-select-item :key="index" :value="item.taxGroupId.id" :text="item.code" v-for="(item, index) in taxGroups" />
              </vs-select>
            </SidebarItem>
          </section>
          <section class="grid grid-cols-5 gap-4 px-6" v-if="!isSplit && !isPriceable">
            <SidebarItem
              v-for="priceGroup in priceGroups"
              :key="priceGroup.priceGroupId.id"
              :label="priceGroup.name + ' (' + matchingPriceGroupPrice(product.salesProduct.minPrices, priceGroup.priceGroupId.id) + ')'"
            >
              <NumberInput
                unit="DKK"
                :min="Math.max(matchingPriceGroupPrice(product.salesProduct.minPrices, priceGroup.priceGroupId.id), 0)"
                :value="matchingPriceGroupPrice(product.prices, priceGroup.priceGroupId.id)"
                @input="updatePrice(product.prices, priceGroup.priceGroupId.id, $event)"
              />
            </SidebarItem>
          </section>

          <section class="grid grid-cols-5 gap-4 px-6" v-if="isSplit">
            <SidebarItem v-for="totalPrice in splitTotalPrices" :key="totalPrice.priceGroupId.id" :label="totalPrice.name">
              <NumberInput unit="DKK" :value="totalPrice.price" :disabled="true" />
            </SidebarItem>
          </section>

          <section class="grid grid-cols-4 gap-4 px-6">
            <SidebarItem label="Is sellable?">
              <vs-select v-model="product.isReadyForSale">
                <vs-select-item
                  :key="item.value"
                  :value="item.value"
                  :text="item.name"
                  v-for="item in [
                    { value: false, name: 'No' },
                    { value: true, name: 'Yes' }
                  ]"
                />
              </vs-select>
            </SidebarItem>
          </section>

          <!-- <vs-divider class="col-span-full mb-2" /> -->

          <h3 class="ml-4 mt-2 mb-2" v-if="!isPriceable">Ingredients</h3>
          <div class="table-primary-bg compact-table mx-6 data-list-list-view" v-if="isSplit">
            <vs-table :data="product.salesProduct.splitSalesProductReferences">
              <template slot="thead">
                <vs-th sort-key="number">Product</vs-th>
                <vs-th v-for="priceGroup in priceGroups" :key="priceGroup.priceGroupId.id">{{ priceGroup.name }}</vs-th>
              </template>

              <template slot-scope="{ data }">
                <tbody>
                  <vs-tr :data="tr" :key="tr.id" v-for="tr in data" class="cursor-default">
                    <vs-td>
                      <div class="product-name font-medium truncate flex flex-row items-center">
                        <!-- <img width="40" :src="ProductIcon" /> -->
                        <div class="flex flex-col">
                          <div class="whitespace-nowrap overflow-hidden truncate" style="width: 206px">
                            {{ tr.salesProduct.name }}
                          </div>
                          <div class="flex items-center">
                            <div class="text-sm text-grey">
                              {{ tr.salesProduct.shortId }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </vs-td>
                    <vs-td v-for="priceGroup in priceGroups" :key="priceGroup.priceGroupId.id">
                      <div class="flex flex-col justify-center items-start">
                        <NumberInput
                          :min="
                            Math.max(
                              matchingSplitMinPriceGroupPrice(
                                product.salesProduct.splitSalesProductReferences,
                                tr.salesProductId,
                                priceGroup.priceGroupId.id
                              ),
                              0
                            )
                          "
                          :value="matchingSplitPriceGroupPrice(product.splitPrices, tr.salesProductId, priceGroup.priceGroupId.id)"
                          @input="updateSplitPrice(product.splitPrices, tr.salesProductId, priceGroup.priceGroupId.id, $event)"
                          style="width: 78px"
                        />
                        <div>
                          ({{
                            matchingSplitMinPriceGroupPrice(
                              product.salesProduct.splitSalesProductReferences,
                              tr.salesProductId,
                              priceGroup.priceGroupId.id
                            )
                          }})
                        </div>
                      </div>
                    </vs-td>

                    <vs-td class="whitespace-no-wrap">
                      <feather-icon
                        icon="TrashIcon"
                        class="cursor-pointer"
                        svgClasses="w-5 h-5 hover:text-danger stroke-current"
                        @click.stop="removeItem(tr)"
                      />
                    </vs-td>
                  </vs-tr>
                </tbody>
              </template>
            </vs-table>
          </div>
          <div v-else-if="!isPriceable" class="table-primary-bg compact-table mx-6 data-list-list-view">
            <vs-table :data="product.salesProduct.stockIngredients">
              <template slot="thead">
                <vs-th>Product</vs-th>
                <vs-th>Amount</vs-th>
                <vs-th></vs-th>
                <!-- <vs-th></vs-th> -->
                <vs-th>Can be replaced?</vs-th>
              </template>

              <template slot-scope="{ data }">
                <tbody>
                  <vs-tr :data="ingredient" :key="ingredient.stockProductId" v-for="ingredient in data" class="cursor-default">
                    <vs-td>
                      <div class="product-name font-medium truncate flex flex-row items-center">
                        <!-- <img width="40" :src="ProductIcon" /> -->
                        <div class="flex flex-col">
                          <div class="whitespace-nowrap overflow-hidden truncate" style="width: 206px">
                            {{ ingredient.stockProduct.name }}
                          </div>
                          <div class="text-sm text-grey">
                            {{ ingredient.stockProduct.number }}
                          </div>
                        </div>
                      </div>
                    </vs-td>
                    <vs-td>
                      <NumberSelectInput
                        v-model="ingredient.amount"
                        :unit.sync="ingredient.productUnit"
                        :units="units"
                        style="width: 142px"
                        :compact="true"
                        :disabled="true"
                      />

                      <div v-if="ingredient.canBeReplaced" class="mt-4">
                        <div class="mb-0"><b>House</b> ({{ ingredient.replaceMinPriceCategory1 }}+)</div>
                        <NumberInput
                          class="mt-1"
                          :value="matchingReplacementPrice(ingredient, 'replacePriceCategory1')"
                          @input="updateReplacementPrice(ingredient, 'replacePriceCategory1', $event)"
                          unit="+ DKK"
                          style="width: 124px"
                          :compact="true"
                        />
                      </div>
                    </vs-td>
                    <vs-td>
                      <div class="relative" style="min-width: 278px">
                        <!-- <NumberInput
                          v-model="ingredient.price"
                          unit="DKK"
                          style="width: 124px"
                          :compact="true"
                        />

                        <div
                          class="flex items-center ml-2 text-sm"
                          style="left: 130px"
                        >
                          Min. price:
                          {{ salesProductIngredient.priceMin }} DKK
                        </div> -->
                      </div>

                      <div v-if="ingredient.canBeReplaced" style="margin-top: 50px" class="gap-8 flex">
                        <div>
                          <div class="mb-0"><b>Lux</b> ({{ ingredient.replaceMinPriceCategory2 }}+)</div>
                          <NumberInput
                            class="mt-1"
                            :value="matchingReplacementPrice(ingredient, 'replacePriceCategory2')"
                            @input="updateReplacementPrice(ingredient, 'replacePriceCategory2', $event)"
                            unit="+ DKK"
                            style="width: 124px"
                            :compact="true"
                          />
                        </div>

                        <div>
                          <div class="mb-0"><b>Premium</b> ({{ ingredient.replaceMinPriceCategory3 }}+)</div>
                          <NumberInput
                            class="mt-1"
                            :value="matchingReplacementPrice(ingredient, 'replacePriceCategory3')"
                            @input="updateReplacementPrice(ingredient, 'replacePriceCategory3', $event)"
                            unit="+ DKK"
                            style="width: 124px"
                            :compact="true"
                          />
                        </div>
                      </div>
                    </vs-td>
                    <!-- <vs-td style="max-width: 60px"> -->
                    <!-- <div class="pt-2 h-12 font-bold">
                        ({{ salesProductIngredient.priceMin | numberFormatDK }}
                        -
                        {{ salesProductIngredient.priceMax | numberFormatDK }}
                        DKK)
                      </div> -->
                    <!-- 
                      <div
                        v-if="salesProductIngredient.canBeReplaced"
                        class="mt-2"
                      >
                        <div class="mb-0">
                          <b>Premium</b>
                        </div>
                        <NumberInput
                          class="mt-1"
                          v-model="ingredient.replacePriceCategory3"
                          unit="+ DKK"
                          style="width: 124px"
                          :compact="true"
                        />
                      </div> -->
                    <!-- </vs-td> -->
                    <vs-td class="flex flex-col">
                      <vs-select v-model="ingredient.canBeReplaced" style="width: 68px" :disabled="true">
                        <vs-select-item
                          :key="item.value"
                          :value="item.value"
                          :text="item.name"
                          v-for="item in [
                            { value: false, name: 'No' },
                            { value: true, name: 'Yes' }
                          ]"
                        />
                      </vs-select>
                      <div v-if="ingredient.canBeReplaced" class="mt-8 pt-1">
                        <div>
                          <small class="whitespace-no-wrap absolute mt-5"> Additional price </small>
                        </div>
                      </div>
                    </vs-td>
                  </vs-tr>
                </tbody>
              </template>
            </vs-table>
          </div>
          <div v-if="product.salesProduct.choicePackages.length > 0">
            <h3 class="mt-5 ml-4 mb-2">Package</h3>
            <p class="ml-4 text-sm max-w-md">
              A package is a collection of stock products where one item of the package can be selected when ordering this sales product.
            </p>
            <div class="flex items-start pb-2 mt-2 w-full">
              <div
                class="table-primary-bg mx-6 data-list-list-view compact-table"
                style="min-width: 520px"
                v-for="(choicePackage, index) in product.salesProduct.choicePackages"
                :key="index"
              >
                <vs-table :data="choicePackage.stockIngredients">
                  <template slot="header">
                    <div class="flex justify-between items-center w-full">
                      <h5 class="ml-0 mb-2">{{ choicePackage.name }}</h5>
                    </div>
                  </template>
                  <template slot="thead">
                    <vs-th sort-key="number">Product</vs-th>
                    <vs-th sort-key="amount">Amount</vs-th>
                  </template>

                  <template slot-scope="{ data }">
                    <tbody>
                      <vs-tr :data="tr" :key="tr.stockProductId" v-for="tr in data" class="cursor-default">
                        <vs-td>
                          <div class="product-name font-medium truncate flex flex-row items-center">
                            <!-- <img width="40" :src="ProductIcon" /> -->
                            <div class="flex flex-col">
                              <div class="whitespace-nowrap overflow-hidden truncate" style="width: 206px">
                                {{ tr.stockProduct.name }}
                              </div>
                              <div class="text-sm text-grey">
                                {{ tr.stockProduct.number }}
                              </div>
                            </div>
                          </div>
                        </vs-td>
                        <vs-td>
                          <NumberSelectInput
                            v-model="tr.amount"
                            :unit.sync="tr.productUnit"
                            :units="units"
                            style="width: 142px"
                            :compact="true"
                            :disabled="true"
                          />
                        </vs-td>
                      </vs-tr>
                    </tbody>
                  </template>
                </vs-table>
              </div>
            </div>
          </div>
        </div>
      </template>

      <template #footer>
        <vs-button @click="submitData" :disabled="!isFormValid">Save</vs-button>
        <vs-button type="border" color="danger" class="ml-6" @click="isActive = false">Cancel</vs-button>
      </template>
    </RightSidebar>
  </div>
</template>

<script>
import ProductIcon from "@/assets/images/product-icon.png";
import moment from "moment";
import { mapGetters } from "vuex";
import VenueSelector from "@/components/VenueSelector.vue";
import RightSidebar from "@/components/Custom/RightSidebar.vue";
import SidebarItem from "@/components/Custom/SidebarItem.vue";
import NumberSelectInput from "@/components/Custom/NumberSelectInput.vue";
import NumberInput from "@/components/Custom/NumberInput.vue";
import _ from "lodash";

export default {
  components: {
    VenueSelector,
    RightSidebar,
    SidebarItem,
    NumberSelectInput,
    NumberInput
  },
  data() {
    return {
      ProductIcon,

      isActive: false,
      isLoading: true,

      product: null,

      activeChoiceGroupIndex: null
    };
  },
  computed: {
    ...mapGetters({
      activeVenue: "venues/activeVenue",
      activeCountry: "venues/activeCountry",
      countries: "pos/countries/countries",

      taxGroups: "pos/countrySettings/taxGroups",
      salesProducts: "pos/salesProducts/salesProducts",
      salesGroups: "pos/countrySettings/salesProductGroups",
      stockProducts: "pos/stockProducts/stockProducts",
      priceGroups: "pos/countrySettings/priceGroups",
      units: "pos/countrySettings/units"
    }),
    isPriceable() {
      return this.product.salesProduct.salesProductType === "Priceable";
    },
    isSplit() {
      return this.product.salesProduct.salesProductType === "Split";
    },
    salesSubGroups() {
      return this.salesGroups.find(g => g.salesProductGroupId.id === this.product.salesProduct.salesProductGroupId).validSubGroups;
    },
    isFormValid() {
      return true; // TODO
    },

    splitTotalPrices() {
      return this.priceGroups.map(e => {
        return {
          priceGroupId: e.priceGroupId,
          name: e.name,
          price: _.sumBy(this.product.splitPrices, i => {
            const match = i.prices.find(p => p.priceGroupId === e.priceGroupId.id);
            return match ? parseFloat(match.price) : 0;
          })
        };
      });
    }
  },
  methods: {
    async show(assignedSalesProductId) {
      this.isActive = true;
      this.isLoading = true;

      this.product = await this.$store.dispatch("pos/assignedSalesProducts/getAssignedSalesProduct", assignedSalesProductId);
      console.log("Product:", this.product);
      await this.loadExternalData();

      this.isLoading = false;
    },
    async loadExternalData() {
      await Promise.all([
        // this.$store.dispatch("pos/countries/getCountries"),
        this.$store.dispatch("pos/countrySettings/getCountrySettings"),
        this.$store.dispatch("pos/stockProducts/getStockProducts")
      ]);
    },

    matchingReplacementPrice(ingredient, priceCategory) {
      const match = this.product.stockReplacementPrices.find(p => p.stockProductId === ingredient.stockProductId);

      return match ? match[priceCategory] : 0;
    },

    updateReplacementPrice(ingredient, priceCategory, price) {
      const match = this.product.stockReplacementPrices.find(p => p.stockProductId === ingredient.stockProductId);

      if (match) {
        match[priceCategory] = price;
      } else {
        const newReplacementPrice = {
          stockProductId: ingredient.stockProductId,
          replacePriceCategory1: 0,
          replacePriceCategory2: 0,
          replacePriceCategory3: 0
        };
        newReplacementPrice[priceCategory] = price;
        this.product.stockReplacementPrices.push(newReplacementPrice);
      }
    },

    matchingPriceGroupPrice(priceGroupPrices, priceGroupId) {
      const match = priceGroupPrices.find(p => p.priceGroupId === priceGroupId);
      return match ? match.price : "";
    },

    updatePrice(priceGroupPrices, priceGroupId, price) {
      console.log("Updating price", priceGroupPrices, priceGroupId, price);
      const match = priceGroupPrices.find(p => p.priceGroupId === priceGroupId);
      if (match) {
        match.price = price;
      } else {
        priceGroupPrices.push({
          priceGroupId,
          price
        });
      }
    },

    matchingSplitPriceGroupPrice(splitPrices, salesProductId, priceGroupId) {
      const match = splitPrices.find(p => p.salesProductId === salesProductId);
      return match ? this.matchingPriceGroupPrice(match.prices, priceGroupId) : "";
    },

    matchingSplitMinPriceGroupPrice(minPrices, salesProductId, priceGroupId) {
      const match = minPrices.find(p => p.salesProductId === salesProductId);
      return match ? this.matchingPriceGroupPrice(match.minPrices, priceGroupId) : "";
    },

    updateSplitPrice(splitPrices, salesProductId, priceGroupId, price) {
      console.log(
        "Updating split price",
        JSON.parse(JSON.stringify(this.product)),
        JSON.parse(JSON.stringify(splitPrices)),
        salesProductId,
        priceGroupId,
        price
      );
      const match = splitPrices.find(p => p.salesProductId === salesProductId);
      if (match) {
        this.updatePrice(match.prices, priceGroupId, price);
      } else {
        const newSplitPrice = {
          salesProductId,
          prices: []
        };

        splitPrices.push(newSplitPrice);
        this.updatePrice(newSplitPrice.prices, priceGroupId, price);
      }
    },

    formatDate(date) {
      return moment(date).format("DD-MM-YYYY HH:mm");
    },

    onChangePrice(newPrice, item, salesProductItem) {
      console.log("Price change", newPrice, item, salesProductItem);
      const priceMin = salesProductItem.priceMin;
      if (newPrice < priceMin) {
        item.price = priceMin;
      }
      if (isNaN(newPrice)) {
        item.price = priceMin;
      }
    },

    async submitData() {
      console.log("Submitting DTO", this.product);

      try {
        await this.$store.dispatch("pos/assignedSalesProducts/updateAssignedSalesProduct", {
          assignedSalesProductId: this.product.id,
          assignedSalesProductDto: this.product
        });

        this.$store.dispatch("pos/assignedSalesProducts/getAssignedSalesProductsByVenue", this.product.venueId);

        this.product = null;
        this.isActive = false;
        this.isLoading = true;

        this.$vs.notify({
          title: "Success",
          text: `Successfully updated venue stock product`
        });
      } catch (error) {
        this.$vs.notify({
          title: "Error",
          color: "danger",
          text: `Failed to update venue stock product: ${error}`
        });

        this.isLoading = false;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.custom-color-picker {
  appearance: none;
  border: none;
  background-color: transparent;

  &::-webkit-color-swatch {
    border: none;
    border-radius: 12px;
    box-shadow: 2px 4px 12px 0 var(--color-picker-color);
  }
  &::-webkit-color-swatch-wrapper {
    padding: 16px;
  }
}
</style>